import React, { useEffect, useRef } from "react";
import { Chart } from "chart.js/auto";

const ProgressChart = ({
  type = "doughnut",
  labels = [],
  data = [],
  colors = ["#94A3B8", "#1D4ED8", "#059669"],
}) => {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);

  useEffect(() => {
    if (!chartRef.current) return;

    const ctx = chartRef.current.getContext("2d");

    if (chartInstanceRef.current) {
      chartInstanceRef.current.destroy();
    }

    chartInstanceRef.current = new Chart(ctx, {
      type,
      data: {
        labels,
        datasets: [
          {
            data,
            backgroundColor: colors,
            borderWidth: 0,
            borderRadius: type === "bar" ? 6 : 0,
            maxBarThickness: 42,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: type === "doughnut" ? "68%" : undefined,
        plugins: {
          legend: {
            position: "bottom",
            labels: {
              boxWidth: 12,
              padding: 14,
              usePointStyle: true,
            },
          },
        },
        scales:
          type === "bar"
            ? {
                x: {
                  grid: { display: false },
                },
                y: {
                  beginAtZero: true,
                  ticks: { precision: 0 },
                  grid: { color: "rgba(148, 163, 184, 0.2)" },
                },
              }
            : undefined,
      },
    });

    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }
    };
  }, [type, labels, data, colors]);

  return (
    <div style={{ height: 260, position: "relative" }}>
      <canvas ref={chartRef} />
    </div>
  );
};

export default ProgressChart;
